<template lang="pug">
    div
        template(v-if="$device.isSmall")
            Overlay(
                v-show="activeOverlay === 'sortMenu'"
                uniqueKey="sortMenu"
                title="Sort"
                :enableDarkMode="true"
                @close="close"
            )
                SearchSortBy
                    template(#sort="{ label, isActive }")
                        div(
                            class="sort bg-white p-4 mb-4 cursor-pointer border-solid rounded text-lg"
                            :class="isActive ? 'is-active border-2 border-action' : 'border border-gray-light'"
                        ) {{ label }}

                template(#footer)
                    BaseButton(@click.native="close" class="w-full") Close

        template(v-else)
            div(class="flex items-center text-sm font-bold")
                span Sort By:&nbsp;
                SearchSortBy
</template>

<script>
import SearchSortBy from '@/components/search/sortBy'
import BaseButton from '@/components/baseButton'
const Overlay = () => import(/* webpackChunkName: "overlay" */ '@/components/overlay')

export default {
    name: 'SortBy',
    components: {
        SearchSortBy,
        BaseButton,
        Overlay,
    },
    computed: {
        activeOverlay() {
            return this.$overlay.state.activeOverlay
        },
    },
    mounted() {
        this.$overlay.registerUrlKey('sortMenu')
    },
    methods: {
        close() {
            this.$overlay.hide()
        },
    },
}
</script>

<style lang="stylus" scoped>
.sort
    &:before
        content ''
        width 20px
        height 20px
        border-radius 50%
        border 2px solid theme('colors.gray.light')
        display inline-block
        margin-right 15px
        position relative
        top 3px

        .is-active&
            border 7px solid theme('colors.action.DEFAULT')
</style>
